import { useContext } from 'react';
import { OSKProfile, ProfileContext } from '../templates/OSKAppProvider';

export const useProfileMetadata = () => {
    const { profile, setProfile } = useContext(ProfileContext);
    return [profile, setProfile] as [OSKProfile, (profile: OSKProfile) => void];
};
